/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inner_Safe_Shell_TearInputs */

const fr_inner_safe_shell_tear = /** @type {(inputs: Inner_Safe_Shell_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

/**

* @param {Inner_Safe_Shell_TearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inner_safe_shell_tear = /** @type {((inputs?: Inner_Safe_Shell_TearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inner_Safe_Shell_TearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inner_safe_shell_tear(inputs)
});